import { Injectable, EventEmitter } from '@angular/core';
import { Router, Route, UrlTree, UrlSegment } from '@angular/router';
import { UrlSegmentGroup } from '@angular/router/src/url_tree'; 
import { Dictionary } from './dictionary';

export const PRIMARY_OUTLET = 'primary';
export const LOGIN = "/login";
export const DASHBOARD = "dashboard";
export const DASHBOARDS = "dashboards";
export const DEFAULT_PATH = LOGIN;
export const LOGOUT_PATH = "logout";


export const APP_READY = "app_ready";

@Injectable()
export class Utils {
    private _emitters: Dictionary = {};

    constructor(private router:Router) {}

    
    getCharFromCode(code:number, base:number): string {
        if (base) {
            code += base;
        }
        return String.fromCharCode(code);
    }

    private createObservableFor(key: string, isSynchronous:boolean): EventEmitter<any> {
        let emitter: EventEmitter<any> = new EventEmitter(!isSynchronous);
        this._emitters[key] = emitter;
        return emitter;
    }

    getObservable(key:string, isSynchronous:boolean = false): EventEmitter<any> {
        if (this.hasEmitter(key)) {
            return this._emitters[key];
        }
        return this.createObservableFor(key, isSynchronous);
    }


    hasEmitter(key: string): boolean {
        if (this._emitters[key] !== undefined) {
            return true;
        }
        return false;
    }
}


export { DataStore } from './datastore';
export { Dictionary } from './dictionary';
export { PersistTabState } from './persisttabstate';
export { FileSaver } from './filesaver';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/utils/utils.ts